import "./style.css";
import { useTranslation } from "i18n";
import sidebarLuggageImage from "assets/images/sidebar-2-luggage.png";
import Button from "../button";

const Sidebar = ({
  isTwoCheckedBaggageActive,
  isTwoCheckedBaggageRoute,
  onApplyTwoCheckedBaggage,
}) => {
  const { t } = useTranslation();

  const isActionable =
    isTwoCheckedBaggageRoute && !isTwoCheckedBaggageActive;

  const handleApplyFilter = () => {
    if (!isActionable) return;
    onApplyTwoCheckedBaggage?.();
  };

  const titleKey = isTwoCheckedBaggageRoute
    ? isTwoCheckedBaggageActive
      ? "sidebar.activeTitle"
      : "sidebar.title"
    : "sidebar.defaultTitle";
  const descriptionKey = isTwoCheckedBaggageRoute
    ? isTwoCheckedBaggageActive
      ? "sidebar.activeDescription"
      : "sidebar.description"
    : "sidebar.defaultDescription";

  return (
    <aside
      className={[
        "search-sideBar-wrapper",
        isTwoCheckedBaggageActive ? "is-active" : "",
        isActionable ? "is-actionable" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      role={isTwoCheckedBaggageRoute ? "button" : undefined}
      tabIndex={isActionable ? 0 : -1}
      aria-pressed={
        isTwoCheckedBaggageRoute ? isTwoCheckedBaggageActive : undefined
      }
      onClick={handleApplyFilter}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleApplyFilter();
        }
      }}
    >
      <div className="search-sidebar__media">
        <img src={sidebarLuggageImage} alt="" />
        <div className="search-sidebar__media-shade" aria-hidden="true" />
        {isTwoCheckedBaggageRoute && (
          <span className="search-sidebar__media-tag">2×</span>
        )}
      </div>

      <div className="search-sidebar__body">
        {isTwoCheckedBaggageActive && (
          <span className="search-sidebar__badge">
            {t("sidebar.activeBadge")}
          </span>
        )}

        <h2 className="search-sidebar__title">{t(titleKey)}</h2>
        <p className="search-sidebar__text">{t(descriptionKey)}</p>

        {isTwoCheckedBaggageRoute && (
          <Button
            type="button"
            className={`search-sidebar__cta ${
              isTwoCheckedBaggageActive ? "is-active" : ""
            }`}
            onClick={(event) => {
              event.stopPropagation();
              handleApplyFilter();
            }}
            disabled={isTwoCheckedBaggageActive}
          >
            {t(
              isTwoCheckedBaggageActive
                ? "sidebar.activeCta"
                : "sidebar.cta"
            )}
          </Button>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
